module.exports = __webpack_public_path__ + "static/media/Add-white.220650ce.svg";